import {Component, OnInit} from '@angular/core';
import {Brand} from "../../models/brand";
import {OwlOptions} from "ngx-owl-carousel-o";
import {StoresService} from "../../../admin/services/stores.service";
import {Store} from "../../../admin/models/store";

@Component({
    selector: 'app-stores',
    templateUrl: './stores.component.html',
    styleUrls: ['./stores.component.css']
})
export class StoresComponent implements OnInit {


    stores: Store[] = [];

    lang = '';
    lang_suffix=''
    customOptions: OwlOptions = {
        loop: false,
        mouseDrag: false,
        touchDrag: true,
        pullDrag: true,
        lazyLoad: true,
        margin: 40,
        dots: false,
        navSpeed: 200,
        nav: false,
        navText: ["<div class='nav-btn prev-slide  p-slider-arrow-left'>" +
        "<i class='la la-chevron-circle-left'></i></div>",
            "<div class='nav-btn next-slide p-slider-arrow-right'><i class='la la-chevron-circle-right'></i></div>"],
        // navText: [ '<i class="fa-chevron-left"></i>', '<i class="fa-chevron-right></i>"' ],
        autoHeight: true,
        slideBy: '4',
        responsive: {
            0: {
                items: 5
            },
            400: {
                items: 5
            },
            740: {
                items: 6
            },
            840: {
                items: 8
            },
            900: {
                items: 10
            },
            940: {
                items: 12
            }
        }
    };


    constructor(private storesService: StoresService) {
    }

    ngOnInit(): void {

        this.loadStores();
        this.lang = this.storesService.getCurrentLang();
        if(this.lang == 'ar')
        {
            this.lang_suffix = '_ar'
        }


    }


    loadStores() {

        this.storesService.getStores().subscribe(stores => {

            this.stores = stores;

        });

    }

}
